import React from 'react';

export default function ConstellationBackdrop({ accent = '#e4e4e8', variant = 'default' }) {
  return (
    <div
      className={`constellation-flow-bg constellation-flow-bg--${variant}`}
      style={{ '--constellation-accent': accent }}
      aria-hidden="true"
    >
      <div
        className="constellation-flow-planet"
        style={{ backgroundImage: "url('/assets/arclipse-planet.png')" }}
      />
      <div className="constellation-flow-accent" />
      <div className="constellation-flow-scrim" />
      <div className="constellation-flow-grain" />
    </div>
  );
}
